import { useEffect, useState } from "react";
import Invite from "../models/Invite";
import Widget from "../_components/Widget";
import InviteController from "../controllers/InviteController";
import { usePlan } from "../_providers/PlanProvider";
import { useAuth } from "../_providers/AuthProvider";

const PendingInvite = () => {
    const [pendingInvites, setPendingInvites] = useState<Invite[]>([]);
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(true);

    const { selectedPlan } = usePlan();
    const { user } = useAuth();

    const reloadData = () => {
        if(!selectedPlan) {
            setError("No plan selected");
            setLoading(false);
            return;
        }
        if(!user) {
            setError("Authentication Error");
            setLoading(false);
            return;
        }
        Promise.all([
            InviteController.getPendingInvites(selectedPlan.uid),
        ]).then(([pendingInvites]) => {
            setPendingInvites(pendingInvites);
            setLoading(false);
        }).catch((error) => {
            setError(error.message);
            setLoading(false);
        });
    }

    const deleteInvite = (invite: Invite) => {
        InviteController.declineInvite(invite).then(() => {
            setPendingInvites(pendingInvites.filter((i) => i.uid !== invite.uid));
        }
        ).catch((error) => {
            setError(error.message);
        });
    }

    useEffect(() => {
        reloadData();
    }, []);

    if (selectedPlan?.owner !== user?.uid) return null;
    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error}</p>;
    return (
        <Widget title="Pending Invites" flex={1} minWidth="300px">
            {pendingInvites.length > 0 ? (
                <div>
                    {pendingInvites.map((invite, index) => (
                        <div key={index} className="transaction dark">
                            <p>{invite.email}</p>
                            <p className="inline_btn" onClick={() => deleteInvite(invite)}><i className="fa-solid fa-trash"></i></p>
                        </div>
                    ))}
                </div>
            ) : (
                <p>No pending invites</p>
            )}
        </Widget>
    );
}
export default PendingInvite;